
export default {
  nav: {
    home: 'Ana Sayfa',
    about: 'Hakkımızda',
    services: 'Hizmet Alanları',
    references: 'Referanslar',
    contact: 'İletişim'
  },
  hero: {
    title: {
      line1: 'Modern Sulama',
      line2: 'Çözümleri'
    },
    subtitle: 'Tarımsal verimliliğinizi artıran profesyonel sulama sistemleri',
    cta: {
      about: 'Hakkımızda',
      contact: 'İletişime Geç'
    },
    slides: {
      slide1: {
        title: 'Modern Sulama Çözümleri',
        subtitle: 'Tarımsal verimliliğinizi artıran profesyonel sulama sistemleri'
      },
      slide2: {
        title: 'Akıllı Sulama Teknolojisi',
        subtitle: 'Gün batımında çalışan otomatik sulama sistemleri'
      },
      slide3: {
        title: 'Sürdürülebilir Tarım',
        subtitle: 'Çevre dostu ve verimli sulama çözümleri'
      },
      slide4: {
        title: 'Sera Sulama Sistemleri',
        subtitle: 'Kontrollü ortam tarımı için özel sulama teknolojileri'
      }
    }
  },
  features: {
    title: 'Neden Bizi Seçmelisiniz?',
    subtitle: 'Modern teknoloji ve uzman ekibimizle tarımsal verimliliğinizi en üst seviyeye çıkarıyoruz.',
    efficiency: {
      title: 'Yüksek Verimlilik',
      desc: 'Su tasarrufu sağlayan modern damla sulama sistemleri ile %40\'a varan verimlilik artışı'
    },
    sustainable: {
      title: 'Sürdürülebilir Çözümler',
      desc: 'Çevre dostu teknolojiler ile doğayı koruyarak tarımsal üretim'
    },
    reliable: {
      title: 'Güvenilir Hizmet',
      desc: '25 yıllık deneyim ve 7/24 teknik destek ile kesintisiz hizmet'
    }
  },
  values: {
    title: 'Değerlerimiz',
    subtitle: 'Müşteri memnuniyeti odaklı yaklaşımımızla sektörde öncü olmaya devam ediyoruz.',
    trust: {
      title: 'Güven',
      desc: 'Şeffaf iş süreçleri ve kaliteli hizmet anlayışı'
    },
    quality: {
      title: 'Kalite',
      desc: 'Uluslararası standartlarda ekipman ve malzeme kullanımı'
    },
    satisfaction: {
      title: 'Memnuniyet',
      desc: 'Müşteri odaklı çözümler ve sürekli destek'
    },
    nature: {
      title: 'Doğa Dostu',
      desc: 'Çevreye saygılı ve sürdürülebilir teknolojiler'
    }
  },
  stats: {
    projects: 'Tamamlanan Proje',
    experience: 'Yıl Deneyim',
    customers: 'Mutlu Müşteri',
    support: 'Teknik Destek'
  },
  gallery: {
    title: 'Projelerimiz',
    subtitle: 'Gerçekleştirdiğimiz başarılı sulama projelerinden örnekler',
    installation: 'Sistem Kurulumu',
    'installation.desc': 'Profesyonel ekibimizle hızlı ve güvenli kurulum',
    active: 'Aktif Sistemler',
    'active.desc': 'Çalışan sulama sistemlerimizden görüntüler',
    planning: 'Proje Planlama',
    'planning.desc': 'Detaylı mühendislik çalışmaları ve planlama'
  },
  cta: {
    title: 'Projenizi Hayata Geçirelim',
    subtitle: 'Uzman ekibimizle iletişime geçin, size özel sulama çözümü geliştirelim.',
    contact: 'İletişime Geç',
    services: 'Hizmetlerimiz'
  },
  language: {
    label: 'Dil',
    switch: 'English'
  },
  social: {
    followUs: 'Bizi Takip Edin',
    facebook: 'Facebook',
    twitter: 'Twitter',
    linkedin: 'LinkedIn',
    instagram: 'Instagram'
  },
  common: {
    phone: '+90 553 414 52 63',
    email: 'bilgi@guventar.com',
    address: 'Cumalı Mh. Antalya Cd. No:9, Serik/Antalya',
    workingHours: 'Çalışma Saatleri',
    followUs: 'Bizi Takip Edin'
  },
  contact: {
    hero: {
      title: 'İletişime Geçin',
      subtitle: 'Uzman ekibimizle iletişime geçin, size özel sulama çözümü geliştirelim'
    },
    info: {
      title: 'İletişim Bilgileri',
      address: {
        title: 'Adres'
      },
      phone: {
        title: 'Telefon'
      },
      email: {
        title: 'E-posta'
      },
      hours: {
        title: 'Çalışma Saatleri',
        weekdays: 'Pazartesi - Cumartesi: 08:00 - 18:00',
        weekend: 'Pazar: Kapalı'
      }
    },
    whatsapp: {
      title: 'WhatsApp İletişim',
      desc: 'Hızlı destek için WhatsApp üzerinden bize ulaşın',
      button: 'WhatsApp\'tan Yaz'
    },
    form: {
      title: 'Mesaj Gönderin',
      name: 'Ad Soyad',
      'name.placeholder': 'Adınızı ve soyadınızı girin',
      phone: 'Telefon',
      'phone.placeholder': 'Telefon numaranızı girin',
      email: 'E-posta',
      'email.placeholder': 'E-posta adresinizi girin',
      subject: 'Konu',
      'subject.placeholder': 'Bir konu seçin',
      'subject.drip': 'Damla Sulama Sistemleri',
      'subject.sprinkler': 'Yağmurlama Sistemleri',
      'subject.automation': 'Otomasyon Sistemleri',
      'subject.maintenance': 'Bakım ve Onarım',
      'subject.other': 'Diğer',
      message: 'Mesaj',
      'message.placeholder': 'Mesajınızı yazın...',
      'message.limit': 'karakter',
      submit: 'Mesaj Gönder'
    },
    map: {
      title: 'Konum'
    }
  }
};
